<template>
  <v-dialog v-model="dialog.show" max-width="600" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row align="center">
            <v-col cols="12">
              <v-text-field
                v-model="consorcio.taxaCotaReposicao"
                label="Taxa da Cota de Reposição"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="consorcio.shareText"
                label="Texto para Compartilhar"
                :rules="[rules.required]"
              ></v-textarea>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="consorcio.faixaAdimplencia1"
                label="Faixa de Inadimplência 1"
                :rules="[rules.required, rules.isNumber]"

              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="consorcio.faixaAdimplencia2"
                label="Faixa de Inadimplência 2"
                :rules="[rules.required, rules.isNumber]"
              ></v-text-field>
            </v-col>

          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
          >Salvar</v-btn
        >

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import Parametro from "@/services/parametro";
import { mapActions } from "vuex";

export default {
  name: "DialogFormConsorcio",

  data() {
    return {
      dialog: {
        show: false,
        title: "",
      },
      consorcio: {
        empresa: "",
        id: "",
        taxaCotaReposicao: "",
        textoCompartilhar: "",
        faixaAdimplencia1: "",
        faixaAdimplencia2: "",
      },
      serviceParametro: new Parametro(),
      rules,

    };
  },

  methods: {
      ...mapActions("parametros_empresa", ["setParametros"]),

    async updateVuex(item){
        const response = await this.serviceParametro.getByEmpresa(item.empresa)
        this.setParametros(response)
    },
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.consorcio.taxaCotaReposicao = parseFloat(
            this.consorcio.taxaCotaReposicao
          );
          this.consorcio.faixaAdimplencia1 *= 1.0
          this.consorcio.faixaAdimplencia2 *= 1.0
          const response = await this.serviceParametro.updateParametro({
            ...this.consorcio,
          });
          this.updateVuex(this.consorcio)

          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao editar parametro Consorcio");
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.dialog.show = false;
    },

    show(item) {
      this.consorcio = { ...item };
      this.dialog.title = "Editar Parametro Consorcio";
      this.dialog.edit = true;
      this.dialog.show = true;
    },
  },
};
</script>
